import React from 'react'

const Loginbtn = ({
    handleClick,
    type,
    btnName,
    className,
    disablebtn,
    loader
}) => {
    
    return (
        <div>
            <button
                type={type}
                className={className}
                onClick={handleClick}
                disabled={disablebtn}
            >
                {loader && (<span className="spinner-border spinner-border-sm mx-1" name="spinner" role="status" aria-hidden="true"></span>)}{btnName}
            </button>
        </div>
    )
}

export default Loginbtn
